import { useRef, useState } from 'react';

function useInfiniteQueryPage<TData extends Array<any>>({
  data,
  hasNextPage,
  fetchNextPage,
  rowsPerPage = 20,
  isSearchActive,
  isFetching,
}: {
  data: TData;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  rowsPerPage?: number;
  isSearchActive?: boolean;
  isFetching: boolean;
}) {
  const highestVisitedPage = useRef(0);

  const [page, setPage] = useState(0);

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedItems = data.slice(startIndex, endIndex) as TData;

  const shouldShowPagination = data.length > rowsPerPage || hasNextPage;

  const shouldShowEmptyState = !data.length && !isSearchActive && !isFetching;

  const onPageChange = (newPage: number) => {
    setPage(newPage);
    if (newPage > highestVisitedPage.current && hasNextPage && !isFetching) {
      highestVisitedPage.current = newPage;
      fetchNextPage();
    }
  };

  const resetPage = () => {
    setPage(0);
  };

  return {
    page,
    displayedItems,
    shouldShowPagination,
    shouldShowEmptyState,
    onPageChange,
    resetPage,
    rowsPerPage,
  };
}

export default useInfiniteQueryPage;
